<template>
    <q-btn
        color="negative"
        icon="delete_forever"
        :label="what && !iconOnly ? $t('delete_what', { what }) : undefined"
        no-caps
        type="button"
        @click="!$attrs.onClick && onClick()"
    />
</template>

<script setup>
import { confirmDelete } from 'src/utils/dialogs.js'
import { showSuccessToast } from 'src/utils/toasts.js'

const props = defineProps({
    what: String, // Type of entity being deleted
    name: String, // Any specific name of the entity being deleted (optional)
    delete: Function, // Callback function to do the actual delete
    noConfirm: Boolean, // Skip the delete confirmation dialog?
    iconOnly: Boolean,
})

// Default button click behaviour (you can bind your own click event if wanting something different)
async function onClick() {
    if (!props.noConfirm) await confirmDelete(props.what || trans('record'), props.name)

    let res = await props.delete()
    if (res !== false && props.what && !props.noConfirm) {
        showSuccessToast(trans('delete_success', { what: props.what }))
    }
}
</script>
